module.exports = __webpack_public_path__ + "static/t_324_718-4b4c348fd13b47ff4b2c7f3f7f8654cf.png";